"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoundingMethodList = exports.PenaltyTypeList = exports.payslipManualColumnKeys = exports.PayslipInfoKey = exports.PayslipRowManualColumnKey = exports.SalesTypeList = exports.OrderCourseList = exports.CashCollectionItem = exports.RoleTypeList = exports.DeviceTypeList = exports.AdminTypeList = exports.AccountReceivableTypeList = exports.OrderItemStatusList = exports.OrderStatusList = exports.InputItemCategory = void 0;
var graphql_1 = require("../__generated__/graphql");
exports.InputItemCategory = (_a = {},
    _a[graphql_1.ItemCategory.CAN_BOTTLE] = "缶 / 瓶",
    _a[graphql_1.ItemCategory.SOFT_DRINK] = "ソフトドリンク",
    _a[graphql_1.ItemCategory.COCKTAIL] = "カクテル",
    _a[graphql_1.ItemCategory.SHOT] = "ショット",
    _a[graphql_1.ItemCategory.CHAMPAGNE] = "シャンパン",
    _a[graphql_1.ItemCategory.FOOD] = "フード",
    _a[graphql_1.ItemCategory.BASIC_CHARGE] = "基本料金",
    _a[graphql_1.ItemCategory.SHOCHU] = "焼酎",
    _a[graphql_1.ItemCategory.LIQUEUR] = "リキュール",
    _a[graphql_1.ItemCategory.WINE] = "ワイン",
    _a[graphql_1.ItemCategory.BRANDY] = "ブランデー",
    _a[graphql_1.ItemCategory.NIHONSHU] = "日本酒",
    _a[graphql_1.ItemCategory.INSIDE_CALL] = "場内指名",
    _a[graphql_1.ItemCategory.OTHER] = "その他",
    _a[graphql_1.ItemCategory.FREE_DRINK] = "フリードリンク",
    _a[graphql_1.ItemCategory.FIRST_TIME_ORDER] = "初回用注文",
    _a[graphql_1.ItemCategory.TOKYO_MENU] = "東京メニュー",
    _a[graphql_1.ItemCategory.FIRST] = "ファースト",
    _a[graphql_1.ItemCategory.FIRST_SERVE] = "FS",
    _a);
exports.OrderStatusList = (_b = {},
    _b[graphql_1.OrderStatus.IN_PROGRESS] = "未会計",
    _b[graphql_1.OrderStatus.COMPLETED] = "会計済",
    _b[graphql_1.OrderStatus.CANCELED] = "削除済",
    _b);
exports.OrderItemStatusList = (_c = {},
    _c[graphql_1.OrderItemStatus.OPENED] = "未提供",
    _c[graphql_1.OrderItemStatus.SERVED] = "提供済",
    _c[graphql_1.OrderItemStatus.CANCELED] = "削除",
    _c);
exports.AccountReceivableTypeList = (_d = {},
    _d[graphql_1.AccountReceivableType.ACCOUNT_RECEIVABLE] = "売掛金",
    _d[graphql_1.AccountReceivableType.DEPOSIT] = "入金",
    _d);
exports.AdminTypeList = (_e = {},
    _e[graphql_1.AdminType.MASTER] = "総合管理者",
    _e[graphql_1.AdminType.ADMIN] = "店舗管理者",
    _e[graphql_1.AdminType.COLLECTOR] = "集金担当者",
    _e);
exports.DeviceTypeList = (_f = {},
    _f[graphql_1.DeviceType.CASHIER] = "キャッシャー",
    _f[graphql_1.DeviceType.HALL] = "ホール",
    _f[graphql_1.DeviceType.VIEWER] = "閲覧用",
    _f[graphql_1.DeviceType.KITCHEN] = "キッチン",
    _f[graphql_1.DeviceType.OFFICE_STAFF] = "内勤スタッフ",
    _f);
exports.RoleTypeList = __assign(__assign({}, exports.AdminTypeList), exports.DeviceTypeList);
var CashCollectionItem;
(function (CashCollectionItem) {
    CashCollectionItem["INITIAL_BALANCE"] = "\u524D\u6708\u7E70\u8D8A";
    CashCollectionItem["CASH_SALES"] = "\u73FE\u91D1\u58F2\u4E0A";
    CashCollectionItem["ACCOUNT_RECEIVABLE_DEPOSIT"] = "\u58F2\u639B\u91D1\u5165\u91D1";
    CashCollectionItem["EXPENSE_DEPOSIT"] = "\u5C0F\u53E3\u5165\u91D1";
    CashCollectionItem["COLLECTION"] = "\u96C6\u91D1";
    CashCollectionItem["ADJUSTMENT"] = "\u96D1\u76CA/\u96D1\u640D/\u8ABF\u6574";
})(CashCollectionItem = exports.CashCollectionItem || (exports.CashCollectionItem = {}));
exports.OrderCourseList = (_g = {},
    _g[graphql_1.OrderCourse.NORMAL] = "通常",
    _g[graphql_1.OrderCourse.FIRST_TIME] = "初回",
    _g[graphql_1.OrderCourse.COMPETITOR_NO_SALES] = "同業(売上なし)",
    _g[graphql_1.OrderCourse.ONE_HOUR_NO_EXTENSION] = "1時間制(延長なし)",
    _g);
exports.SalesTypeList = (_h = {},
    _h[graphql_1.SalesType.SHOKEI] = "小計",
    _h[graphql_1.SalesType.SOURIAGE] = "総売上",
    _h);
var PayslipRowManualColumnKey;
(function (PayslipRowManualColumnKey) {
    PayslipRowManualColumnKey["KIMMU_JIKAN"] = "kimmuJikan";
    PayslipRowManualColumnKey["DOHAN_SHO"] = "dohanSho";
    PayslipRowManualColumnKey["JONAI_SHO"] = "jonaiSho";
    PayslipRowManualColumnKey["ZAISEKI_OYOBI_KAKUSHU_TEATE"] = "zaisekiOyobiKakushuTeate";
    PayslipRowManualColumnKey["MIC_BACK"] = "micBack";
    PayslipRowManualColumnKey["DL"] = "dl";
    PayslipRowManualColumnKey["DORYOKU_SHO"] = "doryokuSho";
    PayslipRowManualColumnKey["COUNT_DOWN_TEATE"] = "countDownTeate";
    PayslipRowManualColumnKey["REPEAT_SHO"] = "repeatSho";
    PayslipRowManualColumnKey["SHOW_ROOM"] = "showRoom";
    PayslipRowManualColumnKey["YUKYU_OYOBI_BOTTLE_KAITORI"] = "yukyuOyobiBottleKaitori";
    PayslipRowManualColumnKey["MINYUKIN_SHOKIN_CUT"] = "minyukinShokinCut";
    PayslipRowManualColumnKey["MINYUKIN_CB_CUT"] = "minyukinCbCut";
    PayslipRowManualColumnKey["FUKURI_KOSEIHI"] = "fukuriKoseihi";
    PayslipRowManualColumnKey["MINYUKIN"] = "minyukin";
    PayslipRowManualColumnKey["JIMUSHO_SHIHARAI"] = "jimushoShiharai";
    PayslipRowManualColumnKey["BACK_MINUS"] = "backMinus";
    PayslipRowManualColumnKey["RYOHI"] = "ryohi";
    PayslipRowManualColumnKey["HAIR_MAKE"] = "hairMake";
    PayslipRowManualColumnKey["INVOICE_MITOROKU"] = "invoiceMitoroku";
    PayslipRowManualColumnKey["OIRI_TASSEI_SHO"] = "oiriTasseiSho";
    PayslipRowManualColumnKey["TOGETSU_BANSU_KYURYO_HENSAI"] = "togetsuBansuKyuryoHensai";
    PayslipRowManualColumnKey["SASHIHIKI_BANSU_ZANGAKU"] = "sashihikiBansuZangaku";
    PayslipRowManualColumnKey["JIYURAN_1"] = "jiyuran1";
    PayslipRowManualColumnKey["JIYURAN_2"] = "jiyuran2";
    PayslipRowManualColumnKey["JIYURAN_3"] = "jiyuran3";
    PayslipRowManualColumnKey["JIYURAN_4"] = "jiyuran4";
    PayslipRowManualColumnKey["JIYURAN_5"] = "jiyuran5";
    PayslipRowManualColumnKey["JIYURAN_6"] = "jiyuran6";
    PayslipRowManualColumnKey["JIYURAN_7"] = "jiyuran7";
    PayslipRowManualColumnKey["JIYURAN_8"] = "jiyuran8";
    PayslipRowManualColumnKey["JIYURAN_9"] = "jiyuran9";
    PayslipRowManualColumnKey["JIYURAN_10"] = "jiyuran10";
    PayslipRowManualColumnKey["TEKIYO"] = "tekiyo";
    // 以下、自動計算もするが手動入力も可な列
    PayslipRowManualColumnKey["KIMMU_NISSU"] = "kimmuNissu";
    PayslipRowManualColumnKey["HOSHOKYU"] = "hoshokyu";
    PayslipRowManualColumnKey["GENKYU_KEKKIN_NISSU"] = "genkyuKekkinNissu";
    PayslipRowManualColumnKey["URIAGE_B"] = "uriageB";
    PayslipRowManualColumnKey["SHIMEI_B"] = "shimeiB";
    PayslipRowManualColumnKey["JONAI_B"] = "jonaiB";
    PayslipRowManualColumnKey["BOTTLE_B"] = "bottleB";
    PayslipRowManualColumnKey["URIAGE_TASSEI_SHO"] = "uriageTasseiSho";
    PayslipRowManualColumnKey["SHIMEI_TASSEI_SHO"] = "shimeiTasseiSho";
    PayslipRowManualColumnKey["URIAGE_NO_SHO"] = "uriageNoSho";
    PayslipRowManualColumnKey["SHIMEI_NO_SHO"] = "shimeiNoSho";
    PayslipRowManualColumnKey["YAKUSHOKU_TEATE_GOKEI"] = "yakushokuTeateGokei";
    PayslipRowManualColumnKey["YAKUSHOKU_TEATE_PERCENT"] = "yakushokuTeatePercent";
    PayslipRowManualColumnKey["YAKUSHOKU_TEATE_YEN"] = "yakushokuTeateYen";
    PayslipRowManualColumnKey["KAIKIN_SHO"] = "kaikinSho";
    PayslipRowManualColumnKey["SOSHIKYUGAKU"] = "soshikyugaku";
    PayslipRowManualColumnKey["SHOTOKUZEI"] = "shotokuzei";
    PayslipRowManualColumnKey["SHOHIZEI"] = "shohizei";
    PayslipRowManualColumnKey["BAKKIN"] = "bakkin";
    PayslipRowManualColumnKey["MAEBARAI_TATEKAE"] = "maebaraiTatekae";
    PayslipRowManualColumnKey["SASHIHIKI_SHIKYUGAKU"] = "sashihikiShikyugaku";
})(PayslipRowManualColumnKey = exports.PayslipRowManualColumnKey || (exports.PayslipRowManualColumnKey = {}));
var PayslipInfoKey;
(function (PayslipInfoKey) {
    PayslipInfoKey["URIAGE_NO_SHO"] = "URIAGE_NO_SHO";
    PayslipInfoKey["SHIMEI_NO_SHO"] = "SHIMEI_NO_SHO";
    PayslipInfoKey["STORE_GOAL_URIAGE"] = "STORE_GOAL_URIAGE";
    PayslipInfoKey["STORE_GOAL_SHIMEI"] = "STORE_GOAL_SHIMEI";
})(PayslipInfoKey = exports.PayslipInfoKey || (exports.PayslipInfoKey = {}));
// 給料一覧手動列の列名リスト(Enumのままだと存在判定もループもできないので変換しておく)
// see: https://qiita.com/hakatakinoco/items/f2a26dc8a5c55034a0fb
exports.payslipManualColumnKeys = Object.values(PayslipRowManualColumnKey);
exports.PenaltyTypeList = (_j = {},
    _j[graphql_1.PenaltyType.STORE] = "店舗罰金",
    _j[graphql_1.PenaltyType.ATTENDANCE] = "勤怠罰金",
    _j);
exports.RoundingMethodList = (_k = {},
    _k[graphql_1.RoundingMethod.ROUND] = "四捨五入",
    _k[graphql_1.RoundingMethod.CEIL] = "切り上げ",
    _k[graphql_1.RoundingMethod.FLOOR] = "切り捨て",
    _k);
//# sourceMappingURL=index.js.map